angular.module('picmonicng').controller('NavigationController', [
  '$scope',
  '$state',
  'LearnService',
  'UserService',
  'SearchService',
  '$modal',
  '$timeout',
  'BrowseService',
  'PermissionsService',
  'MarketOptionsConfig',
  '$document',
  '$location',
  'hotkeys',
  '$cookies',
  '$rootScope',
  'MarketSelectorModalService',
  '$window',
  'GroupBuyService',
  'TwentyFourHourDiscountModal',
  'PQService',
  'nextDomains',
  function (
    $scope,
    $state,
    LearnService,
    UserService,
    SearchService,
    $modal,
    $timeout,
    BrowseService,
    PermissionsService,
    MarketOptionsConfig,
    $document,
    $location,
    hotkeys,
    $cookies,
    $rootScope,
    MarketSelectorModalService,
    $window,
    GroupBuyService,
    TwentyFourHourDiscountModal,
    PQService,
    nextDomains
  ) {
    $scope.$location = $location;
    $scope.PermissionsService = PermissionsService;
    $scope.isActive = function (route) {
      return location.pathname.indexOf(route) === 0;
    };
    $scope.UserService = UserService;
    $scope.SearchService = SearchService;
    $scope.LearnService = LearnService;
    $scope.GroupBuyService = GroupBuyService;
    $scope.$state = $state;
    $scope.MarketOptionsConfig = MarketOptionsConfig;
    $scope.targetSelf = true;
    $scope.nextDomains = nextDomains;

    $scope.isMenuVisible = false;

    $scope.toggleMenu = function () {
      $scope.isMenuVisible = !$scope.isMenuVisible;
    };

    $scope.goToURL = function (url) {
      $scope.isMenuVisible && $scope.toggleMenu();
      if (window.location.href !== url) {
        window.location.href = url;
      }
    };

    var user = $scope.UserService.user;
    $scope.lightMode = user?.settings?.color_mode !== 'dark';
    $scope.showGlossary = user?.lead && user?.cards_viewed ? [100, 105, 203].includes(user.lead) : false;
    $scope.referralInfo =
      user?.role === 'Affiliate' && user?.affiliate
        ? user.affiliate?.affiliate_type === 'Ambassador'
          ? {
              icon: 'verified_user',
              text: 'Ambassador',
              href: '/ambassador-portal',
            }
          : {
              icon: 'attach_money',
              text: 'Affiliate',
              href: '/affiliate-portal',
            }
        : {
            icon: 'groups',
            text: 'Referrals',
            href: '/referrals',
          };

    //TODO: Remove this check once all users are on v2
    if ($cookies.get('picmonic_version') !== 'v1') {
      $scope.items = [
        { label: 'Home', href: '/home', icon: 'home' },
        { label: 'Explore', href: '/explore', icon: 'manage_search' },
        { label: 'Playlists', href: '/myplaylists', icon: 'playlist_play' },
        {
          label: 'Schedule',
          href: '/schedule',
          icon: 'calendar_today',
          hideOnMobile: true,
          iconClass: 'schedule-icon',
        },
        { label: 'Stats', href: '/performance', icon: 'rule' },
        { label: 'Create', href: '/my-picmonics', icon: 'add', hideOnTablet: true },
      ];

      if ($scope.showGlossary) {
        $scope.items.push({
          label: 'Glossary',
          href: '/characters',
          icon: 'menu_book',
          hideOnTablet: true,
        });
      }

      $scope.items.push({
        label: $scope.referralInfo.text,
        href: $scope.referralInfo.href,
        icon: $scope.referralInfo.icon,
        hideOnTablet: true,
      });

      $scope.visibleItems = [...$scope.items];
      $scope.hiddenItems = [];

      // Function to calculate visible items based on screen height
      $scope.updateVisibleItems = function () {
        const navHeight = window.innerHeight;
        const itemHeight = document.querySelector('.nav-item').clientHeight;

        const maxVisibleItems = Math.floor((navHeight - 68) / itemHeight); // 68px is height of Picmonic Logo

        if (maxVisibleItems < $scope.items.length) {
          $scope.visibleItems = $scope.items.slice(0, maxVisibleItems - 1); // Reserve 1 for "More"
          $scope.hiddenItems = $scope.items.slice(maxVisibleItems - 1);
        } else {
          $scope.visibleItems = [...$scope.items];
          $scope.hiddenItems = [];
        }
      };

      // Watch for screen resize events
      angular.element($window).on('resize', function () {
        $scope.$apply($scope.updateVisibleItems);
      });

      // Initialize visible items on page load
      $scope.updateVisibleItems();
    }
    $scope.playerVars = {
      origin: window.location.origin,
    };

    $scope.baseURL = 'pathways';
    $scope.baseURLbutton = 'BUY NOW';

    $scope.can_see_characters = UserService.canSeeGlossary();
    $scope.can_see_lite_switch =
      UserService.user.cards_viewed >= 5 ||
      (UserService.user.email && UserService.user.email.indexOf('@picmonic.com') > -1);

    $scope.closeVideo = function () {
      UserService.see('video_' + BrowseService.showVideo.key);
      BrowseService.showVideo = null;
    };

    $scope.$on('youtube.player.ended', function ($event, player) {
      UserService.see('video_' + BrowseService.showVideo.key);
    });

    // Determine pricing market
    if (UserService.user.lead) {
      market = MarketOptionsConfig.getMarketById(UserService.user.lead);
    } else {
      if ($cookies.get('pls_user_lead')) {
        market = MarketOptionsConfig.getMarketById($cookies.get('pls_user_lead'));
      } else if ($state.current.name.indexOf('question-of-the-day') !== -1) {
        market = MarketOptionsConfig.getMarketBySlug('nursing');
      } else if ($state.params.market) {
        market = MarketOptionsConfig.getMarketBySlug($state.params.market);
      } else {
        market = MarketOptionsConfig.getMarketBySlug('medicine');
      }
    }

    // practice questions for rn/lpn only
    $scope.canSeePracticeQuestions = PQService.canSeePracticeQuestions();
    $scope.isUserHasInstitutionalSub = Boolean(UserService.user && UserService.user.institutional_sub);

    if (window.innerWidth < 480) {
      var timeout;
      var lastScrollTop = 0;
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      $('body').bind('touchmove', function (event) {
        if ($(this).scrollTop() > lastScrollTop) {
          if (
            $rootScope.bodyClass.indexOf('nav-hidden-mobile') === -1 &&
            !BrowseService.moreMenuOpen &&
            !BrowseService.browseOpen &&
            userAgent.indexOf('CriOS') === -1 &&
            !LearnService.preLearnVisible
          ) {
            $scope.$apply(function () {
              $rootScope.bodyClass.push('nav-hidden-mobile');
            });
          }
        } else if ($(this).scrollTop() < lastScrollTop) {
          if (
            $rootScope.bodyClass.indexOf('nav-hidden-mobile') !== -1 &&
            !BrowseService.moreMenuOpen &&
            !BrowseService.browseOpen &&
            userAgent.indexOf('CriOS') === -1 &&
            !LearnService.preLearnVisible
          ) {
            $scope.$apply(function () {
              $rootScope.bodyClass.splice($rootScope.bodyClass.indexOf('nav-hidden-mobile'), 1);
            });
          }
        }

        lastScrollTop = $(this).scrollTop();
      });

      var searchLastScrollTop = 0;
      $('.browse__page--serp').bind('touchmove', function (event) {
        if ($(this).scrollTop() > searchLastScrollTop) {
          if (
            $rootScope.bodyClass.indexOf('nav-browse-hidden-mobile') === -1 &&
            !BrowseService.moreMenuOpen &&
            !LearnService.preLearnVisible
          ) {
            $scope.$apply(function () {
              $rootScope.bodyClass.push('nav-browse-hidden-mobile');
            });
          }
        } else if ($(this).scrollTop() < searchLastScrollTop) {
          if ($rootScope.bodyClass.indexOf('nav-browse-hidden-mobile') !== -1) {
            $scope.$apply(function () {
              $rootScope.bodyClass.splice($rootScope.bodyClass.indexOf('nav-browse-hidden-mobile'), 1);
            });
          }
        }

        searchLastScrollTop = $(this).scrollTop();
      });
    }
    $scope.pricing_url = market.pricing_url;
    $scope.showPremiumButton =
      (UserService.user.user_id && !(UserService.user.is_trial || UserService.user.is_fap)) ||
      market.is_beta ||
      market.pricing_url == '/pricing' ||
      UserService.user.role === 'Professor'
        ? false
        : true;

    if (!market.id) {
      $scope.showPremiumButton = false;
    }

    $scope.redirectToPricing = function () {
      $window.open($scope.pricing_url, '_blank');
    };

    $document.bind('keydown', function (event) {
      if (
        event.keyCode == 13 &&
        (event.target.nodeName == 'A' || ['link', 'button'].indexOf(angular.element(event.target).attr('role')) !== -1)
      ) {
        // Navigate to the focused item
        event.target.click();
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
    });

    $scope.openBetaOptinModal = function () {
      var self = this;

      send_ga('event', 'Navigation', 'Beta Tester Modal Open');

      self.modalInstance = $modal.open({
        templateUrl: '/templates/modals/beta-tester-optin.html',
        windowClass: 'learn-light-modal below-nav',
        backdropClass: 'below-nav',
        controller: [
          '$scope',
          '$modalInstance',
          function ($scope, $modalInstance) {
            $scope.submitted = false;

            $scope.accept = function () {
              send_ga('event', 'Navigation', 'Beta Tester Modal Accept');
              UserService.user.beta_user_flag = 1;
              UserService.user.beta_optin = 1;
              UserService.user.$update().then(function () {
                $scope.submitted = true;
                $timeout(function () {
                  $scope.close();
                  document.location.href = '/my-picmonics';
                }, 2000);
              });
            };

            $scope.close = function () {
              send_ga('event', 'Navigation', 'Beta Tester Modal Close');
              $modalInstance.close();
            };

            $modalInstance.result.finally(function () {
              self.modalInstance = null;
            });
          },
        ],
      });
    };

    $scope.closeBrowse = function () {
      BrowseService.setOpen(false, false);
    };

    hotkeys.add({
      combo: ['q'],
      callback: function (event) {
        event.preventDefault();
        $scope.goToSearch();
      },
    });

    hotkeys.add({
      combo: ['esc'],
      allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
      callback: function () {
        $scope.closeBrowse();
      },
    });

    $scope.goToSearch = function () {
      UserService.see('search', true);
      if (
        !UserService.user.is_trial &&
        UserService.user.cards_viewed > 9 &&
        UserService.user.has_seen.search > 3 &&
        !UserService.seen('search_ugc')
      ) {
        if ((UserService.user.has_seen.shown_onboarding_search_ugc || 0) < 2) {
          UserService.see('shown_onboarding_search_ugc', true);
        } else {
          UserService.see('onboarding_search_ugc');
        }
      }
      if (BrowseService.secondaryState == 'app.search' && BrowseService.secondaryVisible && BrowseService.browseOpen) {
        BrowseService.toggleOpen();
      } else {
        if (!UserService.user.lead & !$cookies.get('pls_user_lead')) {
          var marketselector = MarketSelectorModalService.showMarketSelectorModal(null, true);
          marketselector.result.then(function () {
            BrowseService.go('app.search');
          });
        } else {
          BrowseService.go('app.search');
        }

        if (window.innerWidth > 768) {
          $timeout(function () {
            angular.element(document).find('.search-input').focus();
          });
        }
      }
    };

    $scope.goToPlaylists = function () {
      if (
        BrowseService.secondaryState &&
        BrowseService.secondaryState.indexOf('app.playlists') === 0 &&
        BrowseService.secondaryVisible &&
        BrowseService.browseOpen
      ) {
        BrowseService.toggleOpen();
      } else {
        if (BrowseService.playlistState) {
          BrowseService.go(BrowseService.playlistState, BrowseService.playlistParams);
        } else {
          BrowseService.go('app.playlists');
        }
      }
    };

    $scope.goToQuestions = function () {
      UserService.see('nav_practice_questions_clicked');

      if (
        BrowseService.secondaryState &&
        BrowseService.secondaryState.indexOf('app.practice-questions') === 0 &&
        BrowseService.secondaryVisible &&
        BrowseService.browseOpen
      ) {
        BrowseService.toggleOpen();
      } else {
        // if (BrowseService.questionsState) {
        //   BrowseService.go(
        //     BrowseService.questionsState,
        //     BrowseService.questionsParams
        //   );
        // } else {
        BrowseService.go('app.practice-questions');
        // }
      }
    };

    $scope.shouldShowPQOnboarding = function () {
      // hide if they have ever clicked the navigation button
      if (UserService.seen('nav_practice_questions_clicked')) {
        return false;
      }

      // hide if they are on mobile
      if (window.innerWidth < 769) {
        return false;
      }

      // show only after 3 questions answered
      return PQService.stats.completed >= 3;
    };

    $scope.hidePQFaqs = function () {
      BrowseService.showPQFaqs = false;

      var expires = new Date();
      expires.setTime(expires.getTime() + 30 * 24 * 60 * 60 * 1000);
      $cookies.put('pls_user_browse_pq_faqs_hidden', 1, { expires: expires });
    };

    $scope.browse = function () {
      BrowseService.showPQFaqs = false;

      if (BrowseService.state) {
        if (BrowseService.browseOpen && BrowseService.secondaryVisible) {
          BrowseService.closeSecondary();
          return;
        }

        if (BrowseService.state != 'home' && BrowseService.browseOpen) {
          BrowseService.go('home');
          return;
        }

        BrowseService.closeSecondary();
        BrowseService.toggleOpen();
      } else {
        if (!UserService.user.lead & !$cookies.get('pls_user_lead')) {
          var marketselector = MarketSelectorModalService.showMarketSelectorModal(null, true);
          marketselector.result.then(function () {
            BrowseService.restoreIfNeeded();
          });
        } else {
          BrowseService.restoreIfNeeded();
        }
      }
    };

    // Generic for opening browse in any state
    if ($location.search().browse) {
      BrowseService.go(
        $location.search().browse,
        $location.search().browseParams ? JSON.parse($location.search().browseParams) : ''
      );

      var browseOptions = $location.search().browseOptions ? JSON.parse($location.search().browseOptions) : {};

      if (browseOptions.open === false) {
        $timeout(function () {
          BrowseService.close();
        });
      }
    }

    $scope.twentyFourHourDiscountCheck = function () {
      if (TwentyFourHourDiscountModal.check()) {
        TwentyFourHourDiscountModal.setCTACookie();
      }
    };

    $scope.switchToNext = function () {
      $cookies.remove('picmonic_version');
      $window.location.reload();
    };
  },
]);
